module.exports = __webpack_public_path__ + "static/img/20e.169fe85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20e.jpg
// module id = Sy/E
// module chunks = 0